// src/pages/ConfiguracionPage/ConfiguracionPage.jsx
import React, { useState } from 'react';
import styles from './ConfiguracionPage.module.css';
import EditarRecomendacionesHRA from '../../components/recommendations/EditarRecomendacionesHRA';
import PapeleraEmpresas from '../../components/PapeleraEmpresas.js';

export default function ConfiguracionPage() {
  const [activeSection, setActiveSection] = useState('hra');

  return (
    <div className={styles.page}>
      <main className={styles.content}>
        {activeSection === 'hra' && (
          <>
            <h1>Configuración de HRA</h1>
            <EditarRecomendacionesHRA />
          </>
        )}
        {activeSection === 'burnout' && (
          <>
            <h1>Configuración de Estrés y Burnout</h1>
          </>
        )}
        {activeSection === 'papelera' && <PapeleraEmpresas />}
      </main>
    </div>
  );
}
